


























import { Component, Vue, Prop, Provide, Emit } from 'vue-property-decorator'
import { BLOCK_REGIONS } from '@/components/model/topMenu'

@Component
export default class Banner extends Vue {
  @Prop() public img!: string
  public get subject() {
    return this.$store.state.subject
  }
  public get curUserInfo() {
    return this.$store.state.user_info
      ? this.$store.state.user_info
      : {
          nickname: '',
          subjects: [],
          new_func_visited: 1,
          avatar: '',
          regions: []
        }
  }
  private get isBlockSection() {
    let section =
      this.curUserInfo &&
      this.curUserInfo.regions &&
      this.curUserInfo.regions.length > 0 &&
      this.curUserInfo.regions[2]
    return section && BLOCK_REGIONS.includes(String(section.code))
  }
  private get isPaperAnalysis() {
    const ALLOW_LIST = [202, 203]
    if (this.subject && ALLOW_LIST.indexOf(Number(this.subject.value)) > -1) {
      return true
    } else {
      return false
    }
  }
  public clickSchool() {
    // 广告位点击_题库_首页
    window['sensors'].track('TIKU_homepage_clickAdvert', {
      AdvertURL: '/assessment/lib'
    })
    window.open('/assessment/lib')
  }
  public clickClazz() {
    // 广告位点击_题库_首页
    window['sensors'].track('TIKU_homepage_clickAdvert', {
      AdvertURL: '/clazz/lib'
    })
    window.open('/clazz/lib')
  }
  public clickQuestion() {
    // 广告位点击_题库_首页
    window['sensors'].track('TIKU_homepage_clickAdvert', {
      AdvertURL: '/question'
    })
    window.open('/question')
  }
  public clickMiddle() {
    window['sensors'].track('TIKU_homepage_clickAdvert', {
      AdvertURL: '/junior/real'
    })
    window.open('/junior/real')
  }
  public clickHigh() {
    window['sensors'].track('TIKU_homepage_clickAdvert', {
      AdvertURL: '/senior/real'
    })
    window.open('/senior/real')
  }
  public clickUpload() {
    window['sensors'].track('TIKU_homepage_clickAdvert', {
      AdvertURL: '/sourceupload'
    })
    window.open('/sourceupload')
  }
  public clickUploadIntro() {
    window['sensors'].track('TIKU_homepage_clickAdvert', {
      AdvertURL: '/uploadintro'
    })
    window.open('/uploadintro')
  }
  public clickInfo() {
    window['sensors'].track('TIKU_homepage_clickAdvert', {
      AdvertURL: 'https://school.17zuoye.com/pcview/teacher/beanActivity'
    })
    window.open('https://school.17zuoye.com/pcview/teacher/beanActivity')
  }
  public clickTeacher() {
    window['sensors'].track('TIKU_homepage_clickAdvert', {
      AdvertURL: 'https://school.17zuoye.com/pcview/restaff/live/live/livelisttc'
    })
    window.open('https://school.17zuoye.com/pcview/restaff/live/live/livelisttc')
  }
  public clickPaperAnalysis() {
    window['sensors'].track('TIKU_homepage_clickAdvert', {
      AdvertURL: '/paperAnalysis'
    })
    window.open('/paperAnalysis')
  }
  public clickTermBanner() {
    let paper_type = encodeURIComponent(JSON.stringify([5, '期末']))
    let url = `/?paper_type=${paper_type}`
    window['sensors'].track('TIKU_homepage_clickAdvert', {
      AdvertURL: '/'
    })
    window.open(url)
  }
  // 下载双栏banner点击
  public clickQuestionBanner() {
    window.open('/question')
  }
}
